<script setup lang="ts">
    import { onMounted, ref, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import { useMarketCartStore } from '@/stores/cart.store';
    import { storeToRefs } from 'pinia';

    const router = useRouter();
    const cartStore = useMarketCartStore();
    const { getTotalItems } = storeToRefs(cartStore);
    const sidebarOpen = ref(true);
    const routes = ref([
        { id: 'market-portail', name: 'Portail', path: '/front/market/portail', icon: '/public/icons/icon-profil.svg', initialSidebarOpen: false },
        { id: 'market-produits', name: 'Produits', path: '/front/market/produits', icon: '/public/icons/icon-menu-securite.svg', initialSidebarOpen: false },
        { id: 'market-commandes', name: 'Mes commandes', path: '/front/market/commandes', icon: '/public/icons/icon-idcard-recto.svg', initialSidebarOpen: true },
        { id: 'market-panier', name: `Panier (${cartStore.getTotalItems})`, path: '/front/market/panier', icon: '/public/icons/icon-info-perso.svg', initialSidebarOpen: true },
    ]);
    const activeRoute = ref(router.currentRoute.value.path);

    onMounted(() => {
        router.afterEach((to) => {
            activeRoute.value = to.path;
            updateSidebarStateBasedOnRoute(to.path);
        });
        updateSidebarStateBasedOnRoute(router.currentRoute.value.path);
        cartStore._fetchCart();
    });

    function updateSidebarStateBasedOnRoute(path: string) {
        const matchingRoute = routes.value.find(route => route.path === path);
        if (matchingRoute) {
            sidebarOpen.value = matchingRoute.initialSidebarOpen;
        }
    }

    watch(getTotalItems, (newValue, oldValue) => {
        const cartRouteIndex = routes.value.findIndex(r => r.id == 'market-panier');
        if (cartRouteIndex > -1) {
            routes.value[cartRouteIndex].name = `Panier (${newValue})`
            routes.value = [...routes.value];
        }
    });

    function toggleSidebar() {
        sidebarOpen.value = !sidebarOpen.value
    }
</script>
<template>
    <aside :class="['sidebar', { close: !sidebarOpen }]">
        <div class="sidebar-icon" @click="toggleSidebar">
            <div class="barr1"></div>
            <div class="barr2"></div>
            <div class="barr3"></div>
        </div>
        <div class="sidebar-icon close" @click="toggleSidebar">
            <div class="barr1"></div>
            <div class="barr2"></div>
            <div class="barr3"></div>
        </div>

        <ul class="sidebar-menu-set">
            <router-link :to="route.path" v-for="route in routes" :key="route.path">
                <div :class="['sidebar-menu-animate', { active: activeRoute == route.path }]">
                    <li :class="['sidebar-menu', { active: activeRoute == route.path }]">
                        <img :src="route.icon" class="sidebar-menu-icon" alt="" />
                        <span>{{ route.name }}</span>
                    </li>
                </div>
            </router-link>
        </ul>
    </aside>

    <section class="app-section">
        <div class="page-space-25"></div>
        <router-view />
    </section>
</template>